<template>
  <div class="users-create" v-loading="loading">
    <el-form v-if="!$route.params.company">
      <el-form-item label="Email">
        <el-input v-model="form.email" placeholder="Email"/>
      </el-form-item>
      <el-radio-group v-model="form.rules">

        <el-radio label="admin">Администратор</el-radio>
        <el-radio label="editor">Редактор</el-radio>
        <el-radio label="worker">Стандартный</el-radio>
      </el-radio-group>
      <div class="users-create__buttons">
        <el-button @click="$router.go(-1)">Назад</el-button>
        <el-button type="primary" @click="save">Добавить</el-button>
      </div>
    </el-form>
    <el-form v-else>
      <el-form-item label="Название">
        <el-input v-model="company.name" placeholder="Название"/>
      </el-form-item>
      <el-form-item label="Комментарий">
        <el-input v-model="company.comment" type="textarea" textarea/>
      </el-form-item>
      <el-form-item label="ИНН">
        <el-input v-model="company.inn" type="number"/>
      </el-form-item>
      <el-form-item label="ФОТ">
        <el-input v-model="company.fot" type="number"/>
      </el-form-item>
      <el-form-item label="Смена">
        <el-input v-model="company.hours" type="number"/>
      </el-form-item>
      <div style="display: flex;">
        <div style="display: flex; margin-right: 32px">
          <el-checkbox v-model="company.is_saturday" style="margin-right: 12px">Суббота</el-checkbox>
          <el-input v-model="company.hours_saturday" type="number" style="width: 80px"/>
        </div>
        <div style="display: flex;">
          <el-checkbox v-model="company.is_sunday" style="margin-right: 12px">Воскресенье</el-checkbox>
          <el-input v-model="company.hours_sunday" type="number" style="width: 80px"/>
        </div>
      </div>

      <div class="users-create__buttons">
        <el-button @click="$router.go(-1)">Отмена</el-button>
        <el-button type="primary" @click="createCompany">Добавить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import {v4 as uuidv4} from 'uuid';
import {getDemoUser} from "../../../firestore/demo";
import {apiAuthUrl, apiUrl} from "../../../plugins/firebase";
import {axiosFb} from "../../../plugins/firb";

export default {
  name: 'Create',

  data() {
    return {
      loading: false,
      form: {
        rules: 'worker',
        email: '',
      },
      company: {
        is_saturday: false,
        is_sunday: false,
        hours_saturday: '',
        hours_sunday: '',
        hours: 10,
        fot: '',
        name: '',
        comment: '',
        inn: ''
      },
    };
  },

  methods: {
    async createCompany() {
      await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .add({
          uid: uuidv4(),
          position: '',
          name: this.company.name.trim(),
          email: this.form.email,
          phone: null,
          hours: this.company.hours,

          is_saturday: this.company.is_saturday,
          is_sunday: this.company.is_sunday,
          hours_saturday: this.company.hours_saturday,
          hours_sunday: this.company.hours_sunday,
          inn: this.company.inn,
          comment: this.company.comment,
          company: this.company.name.trim(),
          role: 'worker',
          isCompany: true,
          isInvited: true,
        }).then(() => {
          this.$router.push('/dashboard/users')
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Компания создана',
            type: 'success',
          });
        });
    },
    async save() {
      const isEmpty = Object.values(this.form).some(x => (!x || x.length < 1));
      if (isEmpty) {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Заполните все поля',
          type: 'error',
        });
        return false;
      }

      const currentProjectUser = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where(
          'email',
          '==',
          (this.form.email).toLowerCase(),
        ).get()

      if (currentProjectUser.size > 0) {
        return this.$notify({
          offset: 60,
          title: 'Пользователь с таким email уже добавлен',
          message: '',
          type: 'warning',
        });
      }

      this.loading = true;

      let response = null


      try {
        response = await axiosFb.post(apiUrl + '/onGetUserByEmail?email=' + this.form.email, {data: {
            email: this.form.email.toLowerCase()
          }
        });
      } catch (e) {
        console.log(e, 'error')
        this.loading = false;

        return this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Пользователя с таким email не существует',
          type: 'error',
        });
      }

      console.log(response.data, 'response.data')
      let user_register = {}
      try {
        user_register = await getDemoUser(response.data._id)
      } catch (e) {
      }

      await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .add({
          uid: response.data._id,
          position: '',
          name: user_register.name || '',
          email: this.form.email.toLowerCase(),
          phone: user_register.phone || '',
          company: user_register.company || '',
          role: this.form.rules,
          isInvited: true,
        });

      const projectInfo = await myFirestore.collection('projects').doc(this.$store.state.project.id).get()
      const responseData = projectInfo.data();

      await myFirestore.collection('projects').doc(this.$store.state.project.id).update(
        {
          rules: {
            ...responseData.rules,
            [response.data._id]: this.form.rules,
          },
        },
      )

      this.$store.dispatch('setProject', {
          rules: {
            ...responseData.rules,
            [response.data._id]: this.form.rules,
          }
        }
      )


      this.loading = false;

      this.$notify({
        offset: 60,

        title: 'Успешно!',
        message: 'Пользователь добавлен',
        type: 'success',
      });

      this.$router.go(-1)

      // const path = myFirestore.collection('invites');
      // path
      //   .where('email', '==', String(this.form.email.replace(/\s/g, '')).toLowerCase())
      //   .where('projectId', '==', this.$store.state.project.id)
      //   .limit(1).get().then((doc) => {
      //   const token = crypto.randomBytes(36).toString('hex');
      //   if (doc.size > 0) {
      //     doc.forEach((d) => {
      //       d.ref.delete();
      //     });
      //   }
      //   setTimeout(() => {
      //     myFirestore.collection('invites').add({
      //       projectId: this.$store.state.project.id,
      //       ...this.form,
      //       email: String(this.form.email).replace(/\s/g, '').toLowerCase(),
      //       hash: token,
      //     }).then(() => {
      //       const proxy = firebase.functions().httpsCallable('onMailInvites');
      //       proxy(
      //         {
      //           projectId: this.$store.state.project.id,
      //           invites: [{
      //             token: token,
      //             email: String(this.form.email).replace(/\s/g, '').toLowerCase(),
      //           }],
      //         },
      //       ).finally(() => {
      //         this.$notify({
      //           offset: 60,
      //
      //           title: 'Успешно!',
      //           message: 'Приглашение выслано',
      //           type: 'success',
      //         });
      //       });
      //
      //       this.form = {
      //         rules: '',
      //         email: '',
      //       };
      //     }).finally(() => this.loading = false);
      //   }, 500);
      // }).catch((error) => {
      //   this.$notify({
      //     offset: 60,
      //
      //     title: 'Упс... ',
      //     message: 'Произошла ошибка повторите позже',
      //     type: 'error',
      //   });
      // });
    },
  },
};
</script>

<style scoped lang="scss">
.users-create {
  max-width: 412px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 50px;
  @media screen and (max-width: 764px) {

    .el-radio-group {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .el-radio {
        margin-bottom: 10px;
      }
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/Create.vue